// src/features/interview/components/QuestionDisplay.jsx
import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import Loader from "../../../../components/Loader";
import { useSelector } from "react-redux";
import { INTRODUCTION_TEXT } from "../constants";
import { useTheme } from "../../../../hooks/useTheme";

const QuestionDisplay = ({ state, actions, showStartButton  ,captureScreenshotBlob=()=>{}}) => {
  const {
    isPlayingThankYou,
    currentQuestionIndex,
    isQuestionVisible,
    isNextButtonEnabled,
    isWaitingForTechnicalAcknowledge,
    hideNextButton,
    isNextQuestionLoading,
    isPlaying,
    isSubmitLoading,
    currentQuestion,
    technicalButtonText,
  } = { ...state };

  const {
    handleStartInterview,
    stopRecordingAndProceed,
    handleTechnicalAcknowledge,
  } = actions;

  const {whitelabelEnabled:isWhiteLabelingEnable} = useSelector((state)=>state.miscSlice)
  const { theme } = useTheme();

  return (
    <>
      <div className="flex flex-col justify-between relative p-6 rounded-2xl mx-16">
        <div className="text-center flex-grow flex flex-col">
          {(currentQuestionIndex === -1 || isQuestionVisible || isPlayingThankYou) && (
            <p className={`text-md font-semibold  ${theme === 'light' ? 'text-gray-700' : 'text-[#D9D9D9]'} mb-2`}>
              {isPlayingThankYou ? "Thank you" : ""}
            </p>
          )}
          <p className={`text-xl font-light ${theme === 'light' ? 'text-gray-700' : 'text-[#D9D9D9]'}`}>
            {isPlayingThankYou ? (
              "Your responses have been recorded and will be reviewed by our team."
            ) : currentQuestionIndex === -1 ? (
              INTRODUCTION_TEXT
            ) : isQuestionVisible ? (
              currentQuestion
            ) : (
              <>
                <p></p>
                <p></p>
              </>
            )}
          </p>
        </div>
      </div>

      {/* Start Interview Button */}
      {showStartButton && (
        <div className="flex justify-center mt-4">
          <button
            onClick={()=>{
              // captureScreenshotBlob();
              handleStartInterview();
              
            }}
            className={`group relative py-3 px-8 button text-white font-medium shadow-lg hover:shadow-xl hover:shadow-blue-500/20 transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2`}
          >
            <div className="relative flex items-center justify-center space-x-2">
              <span>Begin Interview</span>
              <ArrowRight className="w-5 h-5 transform transition-transform duration-300 group-hover:translate-x-1" />
            </div>
          </button>
        </div>
      )}

      {/* Next button (normal flow) */}
      {isNextButtonEnabled && !isWaitingForTechnicalAcknowledge && !hideNextButton && !isPlaying && !isNextQuestionLoading && (
        <div className="flex justify-center mt-4">
          <button
            className={`relative py-2 px-6 rounded-[50px]
                    font-medium button text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 group`}
            onClick={stopRecordingAndProceed}
          >
            <span className="relative z-10">Next Question</span>          
          </button>
        </div>
      )}

      {/* Technical acknowledge button */}
      {isWaitingForTechnicalAcknowledge && !isPlaying && !isNextQuestionLoading && isQuestionVisible && (
        <div className="flex justify-center mt-4">
          <button
            className={`button focus:ring-offset-2  text-white py-2 px-6 rounded-[50px] hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2
                     relative group font-medium shadow-lg hover:shadow-xl`}
            onClick={handleTechnicalAcknowledge}
          >
            <span className="relative z-10">{state.technicalButtonText}</span>
          </button>
        </div>
      )}

      {isSubmitLoading && <Loader />}
    </>
  );
};

export default QuestionDisplay;
